/**
 * @fileOverview jquery-autocomplete, the jQuery Autocompleter
 * @author <a href="mailto:dylan@dyve.net">Dylan Verheul</a>
 * @version 2.4.4
 * @requires jQuery 1.6+
 * @license MIT | GPL | Apache 2.0, see LICENSE.txt
 * @see https://github.com/dyve/jquery-autocomplete
 */
(function($) {
    "use strict";

    /**
     * jQuery autocomplete plugin
     * @param {object|string} options
     * @returns (object} jQuery object
     */
    $.fn.autocomplete = function(options) {
        var url;
        if (arguments.length > 1) {
            url = options;
            options = arguments[1];
            options.url = url;
        } else if (typeof options === 'string') {
            url = options;
            options = { url: url };
        }
        var opts = $.extend({}, $.fn.autocomplete.defaults, options);
        return this.each(function() {
            var $this = $(this);
            $this.data('autocompleter', new $.Autocompleter(
                $this,
                $.meta ? $.extend({}, opts, $this.data()) : opts
            ));
        });
    };

    /**
     * Store default options
     * @type {object}
     */
    $.fn.autocomplete.defaults = {
        inputClass: 'acInput',
        loadingClass: 'acLoading',
        resultsClass: 'acResults acScroll',
        noResultsClass: 'acNoResults',
        selectClass: 'acSelect',
        firstItemClass: 'acFirstItem',              // gevonden in code
        lastItemClass: 'acLastItem',                // gevonden in code
        queryParamName: 'searchall',                // idd aangepast, was 'q'
        autoAddOriginURL: false,                    // idd toevoeging groene bolletje
        originSearch: '',                           // idd toevoeging
        extraParams: {},
        remoteDataType: 'json',                     // idd aangepast, was false
        lineSeparator: '\n',
        cellSeparator: '|',
        minChars: 1,
        maxItemsToShow: 10,
        delay: 400,
        useCache: false,                           // idd aangepast, was true maar kan niet aan samen met rowcount feature want dan is er steeds verkeerde rowcount resultaat
        maxCacheLength: 10,
        matchSubset: true,
        matchCase: false,
        matchInside: true,
        mustMatch: false,
        selectFirst: false,
        selectOnly: false,
        showResult: null,
        preventDefaultReturn: 1,
        preventDefaultTab: 0,
        autoFill: false,
        filterResults: false,                      // idd aangepast, was true maar kan niet met rowcount feature
        filter: true, 
        sortResults: false,                        // idd aangepast, was true
        sortFunction: null,
        onItemSelect: null,
        onNoMatch: null,
        relatedInput: {childId: null, searchParam: null},
        onFinish: null,
        matchStringConverter: null,
        beforeUseConverter: null,
        autoWidth: 'min-width',
        useDelimiter: false,
        delimiterChar: ',',
        delimiterKeyCode: 188,
        processData: null,
        onError: null,
        enabled: true,
        disableQuotes: false,
        displayValue: null,                        // gevonden in code
        onParseRemoteData: null,                   // idd, voor tagn
    };

    /**
     * Sanitize result
     * @param {Object} result
     * @returns {Object} object with members value (String) and data (Object)
     * @private
     */
    var sanitizeResult = function(result) {
        var value, data;
        var type = typeof result;
        if (type === 'string') {
            value = result;
            data = {};
        } else if ($.isArray(result)) {
            value = result[0];
            data = result.slice(1);
        } else if (type === 'object') {
            value = result.value;
            data = result.data;
        }
        value = String(value);
        if (typeof data !== 'object') {
            data = {};
        }
        return {
            value: value,
            data: data
        };
    };

    /**
     * Sanitize integer
     * @param {mixed} value
     * @param {Object} options
     * @returns {Number} integer
     * @private
     */
    var sanitizeInteger = function(value, stdValue, options) {
        var num = parseInt(value, 10);
        options = options || {};
        if (isNaN(num) || (options.min && num < options.min)) {
            num = stdValue;
        }
        return num;
    };

    /**
     * Create partial url for a name/value pair
     */
    var makeUrlParam = function(name, value) {
//     	console.log(name, value);
//     	console.log(window.locutus.php.strings.bin2hex(value));

		//value is hier iso88591 encoded zegt mijn test met de autocomplete
		//maar encodeURIComponent maakt van e-met-puntjes %C3%AB dus utf-8
		
//     	let a = encodeURIComponent(value)
//     	console.log(a);
//     	console.log(window.locutus.php.strings.bin2hex(a));
    
        return [name, encodeURIComponent(value)].join('=');
    };

    /**
     * Build an url
     * @param {string} url Base url
     * @param {object} [params] Dictionary of parameters
     */
    var makeUrl = function(url, params) {
        var urlAppend = [];
        $.each(params, function(index, value) {
            urlAppend.push(makeUrlParam(index, value));
        });
        if (urlAppend.length) {
            url += url.indexOf('?') === -1 ? '?' : '&';
            url += urlAppend.join('&');
        }
        return url;
    };

    /**
     * Default sort filter
     * @param {object} a
     * @param {object} b
     * @param {boolean} matchCase
     * @returns {number}
     */
    var sortValueAlpha = function(a, b, matchCase) {
        a = String(a.value);
        b = String(b.value);
        if (!matchCase) {
            a = a.toLowerCase();
            b = b.toLowerCase();
        }
        if (a > b) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    };

    /**
     * Parse data received in text format
     * @param {string} text Plain text input
     * @param {string} lineSeparator String that separates lines
     * @param {string} cellSeparator String that separates cells
     * @returns {array} Array of autocomplete data objects
     */
    var plainTextParser = function(text, lineSeparator, cellSeparator) {
        var results = [];
        var i, j, data, line, value, lines;
        // Be nice, fix linebreaks before splitting on lineSeparator
        lines = String(text).replace('\r\n', '\n').split(lineSeparator);
        for (i = 0; i < lines.length; i++) {
            line = lines[i].split(cellSeparator);
            data = [];
            for (j = 0; j < line.length; j++) {
                data.push(decodeURIComponent(line[j]));
            }
            value = data.shift();
            results.push({ value: value, data: data });
        }
        return results;
    };
    
    // Om html te escapen.
	var htmlEscape = function(value) {
		return $('<div></div>').text(value).html();
	}
	
	
	//conversie
	var utf8StringToLatin1 = function(value) {
		// https://stackoverflow.com/a/5396742/1341553
		var escaped = escape(value);
		try {
			var latin1 = decodeURIComponent(escaped);
		} catch (e) {
			var latin1 = value;
		}
		return latin1;
	}
	
	var utf8ObjectToLatin1 = function(obj) {
		if (obj === null || obj === undefined) {
			return obj;
		}
		
		if (typeof obj === 'object') {
			Object.keys(obj).forEach(function(prop) {
				if (typeof obj[prop] === 'object') {
					obj[prop] = utf8ObjectToLatin1(obj[prop]);
				} else if (typeof obj[prop] === 'string') {
					obj[prop] = utf8StringToLatin1(obj[prop]);
				}
			});
		} else if (typeof obj[prop] === 'string') {
			obj = utf8StringToLatin1(obj);
		}
		
		return obj;
	}


    /**
     * Autocompleter class
     * @param {object} $elem jQuery object with one input tag
     * @param {object} options Settings
     * @constructor
     */
    $.Autocompleter = function($elem, options) {

        /**
         * Assert parameters
         */
        if (!$elem || !($elem instanceof $) || $elem.length !== 1 || $elem.get(0).tagName.toUpperCase() !== 'INPUT') {
            throw new Error('Invalid parameter for jquery.Autocompleter, jQuery object with one element with INPUT tag expected.');
        }

        /**
         * @constant Link to this instance
         * @type object
         * @private
         */
        var self = this;
        
        /**
         * open requests dat je kan cancelen
         */
        this.openRequest = null;

        /**
         * @property {object} Options for this instance
         * @public
         */
        this.options = options;

        /**
         * @property object Cached data for this instance
         * @private
         */
        this.cacheData_ = {};

        /**
         * @property {number} Number of cached data items
         * @private
         */
        this.cacheLength_ = 0;

        /**
         * @property {string} Class name to mark selected item
         * @private
         */
        this.selectClass_ = 'jquery-autocomplete-selected-item';

        /**
         * @property {number} Handler to activation timeout
         * @private
         */
        this.keyTimeout_ = null;

        /**
         * @property {number} Handler to finish timeout
         * @private
         */
        this.finishTimeout_ = null;

        /**
         * @property {number} Last key pressed in the input field (store for behavior)
         * @private
         */
        this.lastKeyPressed_ = null;

        /**
         * @property {string} Last value processed by the autocompleter
         * @private
         */
        this.lastProcessedValue_ = null;

        /**
         * @property {string} Last value selected by the user
         * @private
         */
        this.lastSelectedValue_ = null;

        /**
         * @property {boolean} Is this autocompleter active (showing results)?
         * @see showResults
         * @private
         */
        this.active_ = false;

        /**
         * @property {boolean} Is this autocompleter allowed to finish on blur?
         * @private
         */
        this.finishOnBlur_ = true;

        /**
         * Sanitize options
         */
        this.options.minChars       = sanitizeInteger(this.options.minChars,       $.fn.autocomplete.defaults.minChars,       { min: 0 });
        this.options.maxItemsToShow = sanitizeInteger(this.options.maxItemsToShow, $.fn.autocomplete.defaults.maxItemsToShow, { min: 0 });
        this.options.maxCacheLength = sanitizeInteger(this.options.maxCacheLength, $.fn.autocomplete.defaults.maxCacheLength, { min: 1 });
        this.options.delay          = sanitizeInteger(this.options.delay,          $.fn.autocomplete.defaults.delay,          { min: 0 });
        if (this.options.preventDefaultReturn != 2) {
            this.options.preventDefaultReturn = this.options.preventDefaultReturn ? 1 : 0;
        }
        if (this.options.preventDefaultTab != 2) {
            this.options.preventDefaultTab = this.options.preventDefaultTab ? 1 : 0;
        }

        /**
         * Init DOM elements repository
         */
        this.dom = {};

        /**
         * Store the input element we're attached to in the repository
         */
        this.dom.$elem = $elem;

        /**
         * Switch off the native autocomplete and add the input class
         */
        this.dom.$elem.attr('autocomplete', 'off').addClass(this.options.inputClass);

        /**
         * Create DOM element to hold results, and force absolute position
         */
        this.dom.$results = $('<div></div>').hide().addClass(this.options.resultsClass).css({
            position: 'absolute'
        });
        $('body').append(this.dom.$results);

        /**
         * Attach keyboard monitoring to $elem
         */
        $elem.keydown(function(e) {
            self.lastKeyPressed_ = e.keyCode;
            switch(self.lastKeyPressed_) {

                case self.options.delimiterKeyCode: // comma = 188
                    if (self.options.useDelimiter && self.active_) {
                        self.selectCurrent();
                    }
                    break;

                // ignore navigational & special keys
                case 35: // end
                case 36: // home
                case 16: // shift
                case 17: // ctrl
                case 18: // alt
                case 37: // left
                case 39: // right
                    break;

                case 38: // up
                    e.preventDefault();
                    if (self.active_) {
                        self.focusPrev();
                    } else {
                        self.activate();
                    }
                    return false;

                case 40: // down
                    e.preventDefault();
                    if (self.active_) {
                        self.focusNext();
                    } else {
                        self.activate();
                    }
                    return false;

                case 9: // tab
                    if (self.active_) {
                        self.selectCurrent();
                        if (self.options.preventDefaultTab) {
                            e.preventDefault();
                            return false;
                        }
                    }
                    if (self.options.preventDefaultTab === 2) {
                        e.preventDefault();
                        return false;
                    }
                break;

                case 13: // return
                    if (self.active_) {
                        self.selectCurrent();
                        if (self.options.preventDefaultReturn) {
                            e.preventDefault();
                            return false;
                        }
                    }
                    if (self.options.preventDefaultReturn === 2) {
                        e.preventDefault();
                        return false;
                    }
                break;

                case 27: // escape
                    if (self.active_) {
                        e.preventDefault();
                        self.deactivate(true);
                        return false;
                    }
                break;

                default:
                    self.activate();

            }
        });

        /**
         * Attach paste event listener because paste may occur much later then keydown or even without a keydown at all
         */
        $elem.on('paste', function() {
            self.activate();
        });

        /**
         * Finish on blur event
         * Use a timeout because instant blur gives race conditions
         */
        var onBlurFunction = function() {
            self.deactivate(true);
        }
        $elem.blur(function() {
            if (self.finishOnBlur_) {
                self.finishTimeout_ = setTimeout(onBlurFunction, 200);
            }
        });
        /**
         * Catch a race condition on form submit
         */
        $elem.parents('form').on('submit', onBlurFunction);

    };

    /**
     * Position output DOM elements
     * @private
     */
    $.Autocompleter.prototype.position = function() {
        var offset = this.dom.$elem.offset();
        var height = this.dom.$results.outerHeight();
        var totalHeight = $(window).outerHeight();
        var inputBottom = offset.top + this.dom.$elem.outerHeight();
        var bottomIfDown = inputBottom + height;
        // Set autocomplete results at the bottom of input
        var position = {top: inputBottom, left: offset.left};
        if (bottomIfDown > totalHeight) {
            // Try to set autocomplete results at the top of input
            var topIfUp = offset.top - height;
            if (topIfUp >= 0) {
                position.top = topIfUp;
            }
        }
        this.dom.$results.css(position);
    };

    /**
     * Read from cache
     * @private
     */
    $.Autocompleter.prototype.cacheRead = function(filter) {
        var filterLength, searchLength, search, maxPos, pos;
        if (this.options.useCache) {
            filter = String(filter);
            filterLength = filter.length;
            if (this.options.matchSubset) {
                searchLength = 1;
            } else {
                searchLength = filterLength;
            }
            while (searchLength <= filterLength) {
                if (this.options.matchInside) {
                    maxPos = filterLength - searchLength;
                } else {
                    maxPos = 0;
                }
                pos = 0;
                while (pos <= maxPos) {
                    search = filter.substr(0, searchLength);
                    if (this.cacheData_[search] !== undefined) {
                        return this.cacheData_[search];
                    }
                    pos++;
                }
                searchLength++;
            }
        }
        return false;
    };

    /**
     * Write to cache
     * @private
     */
    $.Autocompleter.prototype.cacheWrite = function(filter, data) {
        if (this.options.useCache) {
            if (this.cacheLength_ >= this.options.maxCacheLength) {
                this.cacheFlush();
            }
            filter = String(filter);
            if (this.cacheData_[filter] !== undefined) {
                this.cacheLength_++;
            }
            this.cacheData_[filter] = data;
            return this.cacheData_[filter];
        }
        return false;
    };

    /**
     * Flush cache
     * @public
     */
    $.Autocompleter.prototype.cacheFlush = function() {
        this.cacheData_ = {};
        this.cacheLength_ = 0;
    };

    /**
     * Call hook
     * Note that all called hooks are passed the autocompleter object
     * @param {string} hook
     * @param data
     * @returns Result of called hook, false if hook is undefined
     */
    $.Autocompleter.prototype.callHook = function(hook, data) {
        var f = this.options[hook];
        if (f && $.isFunction(f)) {
            return f(data, this);
        }
        return false;
    };

    /**
     * Set timeout to activate autocompleter
     */
    $.Autocompleter.prototype.activate = function() {
        if (!this.options.enabled) return;
        var self = this;
        if (this.keyTimeout_) {
            clearTimeout(this.keyTimeout_);
        }
        var value = this.beforeUseConverter(this.dom.$elem.val());
        var delay = this.options.delay;
        //1 karakter is vast nog geen autocomplete. dit loopt altijd achter op de "to be" value
        if (value.length==0) delay += 750;
        
        this.keyTimeout_ = setTimeout(function() {
            self.activateNow();
        }, delay);
    };

    /**
     * Activate autocompleter immediately
     * if value empty string is stop autocompleter
     */
    $.Autocompleter.prototype.activateNow = function() {
        var value = this.beforeUseConverter(this.dom.$elem.val());
        if (value.trim() === '') return;
        if (value !== this.lastProcessedValue_ && value !== this.lastSelectedValue_) {
            this.fetchData(value);
        }
    };

    /**
     * Get autocomplete data for a given value
     * @param {string} value Value to base autocompletion on
     * @private
     */
    $.Autocompleter.prototype.fetchData = function(value) {
        var self = this;
        var processResults = function(results, filter) {
            //als request mislukt komt er false in results (zie fetchRemoteData > ajaxCallback), daar kunnen we niks mee
            // want in filterResults en processData gebeuren er dan dingen op false en dat exceptiont
            if (results === false) return;

            if (self.options.processData) {
                results = self.options.processData(results);
            }
            self.showResults(self.filterResults(results, filter), filter);
        };
        this.lastProcessedValue_ = value;
        if (value.length < this.options.minChars) {
            processResults([], value);
        } else if (this.options.data) {
            processResults(this.options.data, value);
        } else {
            this.fetchRemoteData(value, function(remoteData) {
                processResults(remoteData, value);
            });
        }
    };

    /**
     * Get remote autocomplete data for a given value
     * @param {string} filter The filter to base remote data on
     * @param {function} callback The function to call after data retrieval
     * @private
     */
    $.Autocompleter.prototype.fetchRemoteData = function(filter, callback) {
        var data = this.cacheRead(filter);
        
        if (data) {
            callback(data);
        } else {
            var self = this;
            var dataType = self.options.remoteDataType === 'json' ? 'json' : 'text';
            var ajaxCallback = function(data, textStatus, jqXHR) {
                self.openRequest = null;
                var parsed = false;
                if (data !== false) {
                    parsed = self.parseRemoteData(data);
                    if (self.options.onParseRemoteData) {
	                    self.options.onParseRemoteData(parsed);
	                }
                    self.cacheWrite(filter, parsed);
                }
                self.dom.$elem.removeClass(self.options.loadingClass);
                callback(parsed);
            };
            
            this.dom.$elem.addClass(this.options.loadingClass);
            
            //openstaande requests doen daaropvolgende requests blokkeren door sessions met PHP
            // dus om te voorkomen dat er een hele trits requests open blijft staan stoppen we 
            // het vorige request als er toch zometeen een nieuwe komt
            if (this.openRequest) {
                this.openRequest.abort();
            }
            
            //1 request tegelijk
            this.openRequest = $.ajax({
                url: this.makeUrl(filter),
                success: ajaxCallback,
                error: function(jqXHR, textStatus, errorThrown) {
                    self.openRequest = null;
                    if($.isFunction(self.options.onError)) {
                        self.options.onError(jqXHR, textStatus, errorThrown);
                    } else {
                      ajaxCallback(false);
                    }
                },
                dataType: dataType
            });
        }
    };

    /**
     * Create or update an extra parameter for the remote request
     * @param {string} name Parameter name
     * @param {string} value Parameter value
     * @public
     */
    $.Autocompleter.prototype.setExtraParam = function(name, value) {
        var index = $.trim(String(name));
        if (index) {
            if (!this.options.extraParams) {
                this.options.extraParams = {};
            }
            if (this.options.extraParams[index] !== value) {
                this.options.extraParams[index] = value;
                this.cacheFlush();
            }
        }

        return this;
    };

    /**
     * Build the url for a remote request
     * If options.queryParamName === false, append query to url instead of using a GET parameter
     * @param {string} param The value parameter to pass to the backend
     * @returns {string} The finished url with parameters
     */
    $.Autocompleter.prototype.makeUrl = function(param) {
        var self = this;
        var url = this.options.url;
        var params = $.extend({}, this.options.extraParams);

        if (this.options.queryParamName === false) {
            url += encodeURIComponent(param);
        } else {
            params[this.options.queryParamName] = param;
        }
		
		var out = makeUrl(url, params);
        return out;
    };

    /**
     * Parse data received from server
     * @param remoteData Data received from remote server
     * @returns {array} Parsed data
     */
    $.Autocompleter.prototype.parseRemoteData = function(remoteData) {
        var remoteDataType;
        var data = remoteData;
        if (this.options.remoteDataType === 'json') {
            remoteDataType = typeof(remoteData);
            switch (remoteDataType) {
                case 'object':
                    data = remoteData;
                    break;
                case 'string':
                    data = $.parseJSON(remoteData);
                    break;
                default:
                    throw new Error("Unexpected remote data type: " + remoteDataType);
            }
            
//            console.log(data);

            // als dit uit de ajaxmodule komt dan is het utf-8, maar wel plat encoded als \u00XX 
            // dus dat moet om naar latin1
            data = utf8ObjectToLatin1(data);
            
            return data;
        }
        return plainTextParser(data, this.options.lineSeparator, this.options.cellSeparator);
    };

    /**
     * Default filter for results
     * @param {Object} result
     * @param {String} filter
     * @returns {boolean} Include this result
     * @private
     */
    $.Autocompleter.prototype.defaultFilter = function(result, filter) {
        if (!result.value) {
            return false;
        }

        if (this.options.filterResults) {
            var pattern = this.matchStringConverter(filter);
            var testValue = this.matchStringConverter(result.value);
            if (!this.options.matchCase) {
                pattern = pattern.toLowerCase();
                testValue = testValue.toLowerCase();
            }
            var patternIndex = testValue.indexOf(pattern);
            if (this.options.matchInside) {
                return patternIndex > -1;
            } else {
                return patternIndex === 0;
            }
        }
        return true;
    };

    /**
     * Filter result
     * @param {Object} result
     * @param {String} filter
     * @returns {boolean} Include this result
     * @private
     */
    $.Autocompleter.prototype.filterResult = function(result, filter) {
        // No filter
        if (this.options.filter === false) {
            return true;
        }
        // Custom filter
        if ($.isFunction(this.options.filter)) {
            return this.options.filter(result, filter);
        }
        // Default filter
        return this.defaultFilter(result, filter);
    };

    /**
     * Filter results
     * @param results
     * @param filter
     */
    $.Autocompleter.prototype.filterResults = function(results, filter) {
        var filtered = [];
        var i, result;
        var resultDataLength = 0;
        if (typeof results.data !== 'undefined') {
            resultDataLength = results.data.length;
        }

        for (i = 0; i < resultDataLength; i++) {
            result = sanitizeResult(results.data[i]);
            if (this.filterResult(result, filter)) {
                filtered.push(result);
            }
        }
        if (this.options.sortResults) {
            filtered = this.sortResults(filtered, filter);
        }
        if (this.options.maxItemsToShow > 0 && this.options.maxItemsToShow < filtered.length) {
            filtered.length = this.options.maxItemsToShow;
        }
        results.data = filtered;
        return results;
    };

    /**
     * Sort results
     * @param results
     * @param filter
     */
    $.Autocompleter.prototype.sortResults = function(results, filter) {
        var self = this;
        var sortFunction = this.options.sortFunction;
        if (!$.isFunction(sortFunction)) {
            sortFunction = function(a, b, f) {
                return sortValueAlpha(a, b, self.options.matchCase);
            };
        }
        results.sort(function(a, b) {
            return sortFunction(a, b, filter, self.options);
        });
        return results;
    };

    /**
     * Convert string before matching
     * @param s
     * @param a
     * @param b
     */
    $.Autocompleter.prototype.matchStringConverter = function(s, a, b) {
        var converter = this.options.matchStringConverter;
        if ($.isFunction(converter)) {
            s = converter(s, a, b);
        }
        return s;
    };

    /**
     * Convert string before use
     * @param {String} s
     */
    $.Autocompleter.prototype.beforeUseConverter = function(s) {
        s = this.getValue(s);
        var pv = this.callHook('beforeUseConverter', s);
        if (pv !== false) s = pv;
        return s;
    };

    /**
     * Enable finish on blur event
     */
    $.Autocompleter.prototype.enableFinishOnBlur = function() {
        this.finishOnBlur_ = true;
    };

    /**
     * Disable finish on blur event
     */
    $.Autocompleter.prototype.disableFinishOnBlur = function() {
        this.finishOnBlur_ = false;
    };

    /**
     * Create a results item (LI element) from a result
     * @param result
     */
    $.Autocompleter.prototype.createItemFromResult = function(result) {
        var self = this;
        var $li = $('<li></li>');
        $li.html(this.showResult(result.value, result.data));
         $li.data({value: result.value, data: result.data})
            .mousedown(function() {
                self.selectItem($li);
            })
            .mousedown(self.disableFinishOnBlur)
            .mouseup(self.enableFinishOnBlur);
        $li.data({value: result.value, data: result.data})
            .click(function() {
                self.selectItem($li);
            })
            .mousedown(self.disableFinishOnBlur)
            .mouseup(self.enableFinishOnBlur)
        ;
        return $li;
    };

    /**
     * Get all items from the results list
     * @param result
     */
    $.Autocompleter.prototype.getItems = function() {
        return $('>ul>li', this.dom.$results).not('.allResults');
    };

    /**
     * Show all results
     * @param results
     * @param filter
     */
    $.Autocompleter.prototype.showResults = function(results, filter) {
        var numResults = results.data.length;
        var self = this;
        var $ul = $('<ul></ul>');
        var i, result, $li, autoWidth, first = false, $first = false;

        if (numResults) {
            for (i = 0; i < numResults; i++) {
                result = results.data[i];
                $li = this.createItemFromResult(result);
                $ul.append($li);
                if (first === false) {
                    first = String(result.value);
                    $first = $li;
                    $li.addClass(this.options.firstItemClass);
                }
                if (i === numResults - 1) {
                    $li.addClass(this.options.lastItemClass);
                }
            }
            
            // kan niet als de resultaten uit de cache komen want dan klopt de rowcount niet
            if (results.rowcount !== false && !this.options.useCache){
                if (numResults === 1) {
                    $li = $("<li class='allResults'></li>").html('1 result');
                } else {
                    $li = $("<li class='allResults'></li>").html(results.rowcount + ' results');
                }
                $ul.append($li);
            }
            
            this.dom.$results.html($ul).show();
            this.active_ = true;
        //Als er geen resultaten zijn maar wel input
        } else if (!numResults && (self.lastProcessedValue_ !== null && self.lastProcessedValue_.length > 0)) {
            $ul.append($("<li class='"+this.options.noResultsClass+"'></li>").html('No results found'));
            this.dom.$results.html($ul).show();
            this.active_ = true;
        } else {
            this.hideResults();
            this.active_ = false;
        }

        // Always recalculate position since window size or
        // input element location may have changed.
        this.position();
        if (this.options.autoWidth) {
            autoWidth = this.dom.$elem.outerWidth() - this.dom.$results.outerWidth() + this.dom.$results.width();
            this.dom.$results.css(this.options.autoWidth, autoWidth);
        }
        this.getItems().hover(
			function() {
				// negeer de "no results" regel, want dat is geen selecteerbaar item.
				if (this.classList.contains(self.options.noResultsClass)) return;
				self.focusItem(this); 
			},
            function() { /* void */ }
        );
        if (this.autoFill(first, filter) || this.options.selectFirst || (this.options.selectOnly && numResults === 1)) {
            this.focusItem($first);
        }
    };

    $.Autocompleter.prototype.autoFill = function(value, filter) {
        var lcValue, lcFilter, valueLength, filterLength;
        if (this.options.autoFill && this.lastKeyPressed_ !== 8) {
            lcValue = String(value).toLowerCase();
            lcFilter = String(filter).toLowerCase();
            valueLength = value.length;
            filterLength = filter.length;
            if (lcValue.substr(0, filterLength) === lcFilter) {
                var d = this.getDelimiterOffsets(this.dom.$elem.val());
                var pad = d.start ? ' ' : ''; // if there is a preceding delimiter
                this.setValue( pad + value );
                var start = filterLength + d.start + pad.length;
                var end = valueLength + d.start + pad.length;
                this.selectRange(start, end);
                return true;
            }
        }
        return false;
    };

    $.Autocompleter.prototype.focusNext = function() {
        this.focusMove(+1);
    };

    $.Autocompleter.prototype.focusPrev = function() {
        this.focusMove(-1);
    };

    $.Autocompleter.prototype.focusMove = function(modifier) {
        var $items = this.getItems();
        modifier = sanitizeInteger(modifier, 0);
        if (modifier) {
            for (var i = 0; i < $items.length; i++) {
                if ($($items[i]).hasClass(this.selectClass_)) {
                    this.focusItem(i + modifier, modifier);
                    return;
                }
            }
        }
        this.focusItem(0);
    };

    $.Autocompleter.prototype.focusItem = function(item, direction) {
        var $item, $items = this.getItems();
        if ($items.length) {
            $items.removeClass(this.selectClass_).removeClass(this.options.selectClass);
            if (typeof item === 'number') {
                if (item < 0) {
                    item = 0;
                } else if (item >= $items.length) {
                    item = $items.length - 1;
                }
                $item = $($items[item]);
            } else {
                $item = $(item);
            }
            if ($item) {
                $item.addClass(this.selectClass_).addClass(this.options.selectClass);
            }

            var $resultBox = $("> ul", this.dom.$results);
            var itemheight = $(">ul>li", this.dom.$results).outerHeight(true);
            var position = $item.position();

            // alleen scrollen als je op pijltoetsen hebt gedrukt (dan is direction meegegeven)
            if (direction !== undefined && (position.top+itemheight > $resultBox.height() ||
                position.top < $resultBox.height())) {
                $resultBox.scrollTop($resultBox.scrollTop() + (direction*itemheight));
            }
            
            var value = $item.data('value');
            var data  = $item.data('data');
            this.callHook('onItemFocus', { value: value, data: data });
        }
    };

    $.Autocompleter.prototype.selectCurrent = function(deactivate) {
        var $item = $('li.' + this.selectClass_, this.dom.$results);
        if ($item.length === 1) {
            this.selectItem($item, deactivate);
        } else {
            this.deactivate(false);
        }
    };

    $.Autocompleter.prototype.selectItem = function($li, deactivate) {
        // default value for deactivate is true, if deactivate is given then use that value
        // in some cases we dont want to hide the result screen
        deactivate = typeof deactivate != 'undefined' ? deactivate : true;
        var value = $li.data('value');
        var data = $li.data('data');
        var displayValue = this.displayValue(value, data);
        var processedDisplayValue = this.beforeUseConverter(displayValue);
        this.lastProcessedValue_ = processedDisplayValue;
        this.lastSelectedValue_ = processedDisplayValue;
        var d = this.getDelimiterOffsets(processedDisplayValue);
        var delimiter = this.options.delimiterChar;
        var elem = this.dom.$elem;
        var extraCaretPos = 0;
        if ( this.options.useDelimiter ) {
            // if there is a preceding delimiter, add a space after the delimiter
            if ( elem.val().substring(d.start-1, d.start) == delimiter && delimiter != ' ' ) {
                displayValue = ' ' + displayValue;
            }
            // if there is not already a delimiter trailing this value, add it
            if ( elem.val().substring(d.end, d.end+1) != delimiter && this.lastKeyPressed_ != this.options.delimiterKeyCode ) {
                displayValue = displayValue + delimiter;
            } else {
                // move the cursor after the existing trailing delimiter
                extraCaretPos = 1;
            }
        }
        
		// disable Quotes if disableQuotes is true and if there is white space between text
		// preventDefaultReturn is mostly used for search inputs
		if (this.options.disableQuotes === false && 
		    this.options.preventDefaultReturn == 0 && 
			processedDisplayValue.indexOf(" ") !== -1) {
			
			//split op de field separator
			var parts = displayValue.split('\x1f');
			
			//en quote alleen de complete fields
			parts.forEach(function(e, i) {
				if (e.indexOf(" ") !== -1) {
					parts[i] = '"' + e + '"';
				}
			});
			
			this.setValue(parts.join(' '));
		} else {
			this.setValue(processedDisplayValue);
		}
		
        //change the related child search param to show relative information everytime without reloading the page
        if (this.options.relatedInput.childId != null) {
            // childInputId is the childid
            var childInputId = "#id_" + this.options.relatedInput['childId']
            // childSearchParam is the child search param
            var childSearchParam = this.options.relatedInput['searchParam']
            // change related input id so the child input show everytime relative data
            $(childInputId).data('autocompleter').options.extraParams[childSearchParam] = data[0];
        }
        this.setCaret(d.start + displayValue.length + extraCaretPos);
        this.callHook('onItemSelect', { value: value, data: data });
        if (deactivate) this.deactivate(true);
        elem.focus();
    };

    $.Autocompleter.prototype.displayValue = function(value, data) {
        if ($.isFunction(this.options.displayValue)) {
            return this.options.displayValue(value, data);
        }
        return String(value);
    };

    $.Autocompleter.prototype.hideResults = function() {
        this.dom.$results.hide();
    };

    $.Autocompleter.prototype.deactivate = function(finish) {
        if (this.finishTimeout_) {
            clearTimeout(this.finishTimeout_);
        }
        if (this.keyTimeout_) {
            clearTimeout(this.keyTimeout_);
        }
        if (finish) {
            if (this.lastProcessedValue_ !== this.lastSelectedValue_) {
                if (this.options.mustMatch) {
                    this.setValue('');
                }
                this.callHook('onNoMatch');
                //clean the related child search param to show relative information
                if(this.options.relatedInput.childId != null){
                    //childInputId is the childid
                    var childInputId = "#id_" + this.options.relatedInput['childId'];
                    //childSearchParam is the child search param
                    var childSearchParam = this.options.relatedInput['searchParam'];
                    //change related input id so the child input show everytime relative data
                    $(childInputId).data('autocompleter').options.extraParams[childSearchParam] = undefined;
                }
            }
            if (this.active_) {
                this.callHook('onFinish');
            }
            this.lastKeyPressed_ = null;
            this.lastProcessedValue_ = null;
            this.lastSelectedValue_ = null;
            this.active_ = false;
        }
        this.hideResults();
    };

    $.Autocompleter.prototype.selectRange = function(start, end) {
        var input = this.dom.$elem.get(0);
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(start, end);
        } else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', end);
            range.moveStart('character', start);
            range.select();
        }
    };

    /**
     * Move caret to position
     * @param {Number} pos
     */
    $.Autocompleter.prototype.setCaret = function(pos) {
        this.selectRange(pos, pos);
    };

    /**
     * Get caret position
     */
    $.Autocompleter.prototype.getCaret = function() {
        var $elem = this.dom.$elem;
        var elem = $elem[0];
        var val, selection, range, start, end, stored_range;
        if ($elem.createTextRange) { // IE
            selection = elem.getSelection();
            if (elem.tagName.toLowerCase() != 'textarea') {
                val = $elem.val();
                range = selection.createRange().duplicate();
                range.moveEnd('character', val.length);
                if (range.text === '') {
                    start = val.length;
                } else {
                    start = val.lastIndexOf(range.text);
                }
                range = selection.createRange().duplicate();
                range.moveStart('character', -val.length);
                end = range.text.length;
            } else {
                range = selection.createRange();
                stored_range = range.duplicate();
                stored_range.moveToElementText(elem);
                stored_range.setEndPoint('EndToEnd', range);
                start = stored_range.text.length - range.text.length;
                end = start + range.text.length;
            }
        } else {
            start = $elem[0].selectionStart;
            end = $elem[0].selectionEnd;
        }
        return {
            start: start,
            end: end
        };
    };

    /**
     * Set the value that is currently being autocompleted
     * @param {String} value
     */
    $.Autocompleter.prototype.setValue = function(value) {
        if ( this.options.useDelimiter ) {
            // set the substring between the current delimiters
            var val = this.dom.$elem.val();
            var d = this.getDelimiterOffsets(val);
            var preVal = val.substring(0, d.start);
            var postVal = val.substring(d.end);
            value = preVal + value + postVal;
        }
        this.dom.$elem.val(value);
    };

    /**
     * Get the value currently being autocompleted
     * @param {String} value
     */
    $.Autocompleter.prototype.getValue = function(value) {
        if ( this.options.useDelimiter ) {
            var d = this.getDelimiterOffsets(value);
            return value.substring(d.start, d.end).trim();
        } else {
            return value;
        }
    };

    /**
     * Get the offsets of the value currently being autocompleted
     * 
     * dit werkt op this.dom.$elem.val() maar 
     */
    $.Autocompleter.prototype.getDelimiterOffsets = function(val) {
        if ( this.options.useDelimiter ) {
            var preCaretVal = val.substring(0, this.getCaret().start);
            var start = preCaretVal.lastIndexOf(this.options.delimiterChar) + 1;
            var postCaretVal = val.substring(this.getCaret().start);
            var end = postCaretVal.indexOf(this.options.delimiterChar);
            if ( end == -1 ) end = val.length;
            end += this.getCaret().start;
        } else {
            start = 0;
            end = val.length;
        }
        return {
            start: start,
            end: end
        };
    };
    
    
	//uit de query komt een recordseparator als je >1 kolom merget
	$.Autocompleter.prototype.filterRecordSeparator = function(value) {
		
		//nu de ascii field separator eruit
		var valueParts = String(value).split('\x1f');
		
		//lege records eruit
		var iPartLen = valueParts.length;
		for (var i = 0; i < iPartLen; i++) {
			if (String(valueParts[i]) == '') {
				valueParts.splice(i,1);
				i--;
			}
		}
		
		//dit zou best instelbaar mogen zijn
		return valueParts.join(' | ');
	}
	
	
	/**
	 * Escape regular expression characters.
	 *
	 * @param {string} str The input string
	 *
	 * @return {string}
	 */
	function escapeRegexp(str) {
		return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	}
	
	
	$.Autocompleter.prototype.showResult = function(value,data) {
		//terms zijn de woorden waar de gebruiker op zoekt
		var terms = this.beforeUseConverter(this.dom.$elem.val());
		
		// Hier komen we enkel terecht als er op niets is gezocht maar wel resultaten uit de stream komen.
		if (terms == undefined) {
			var fValue = this.filterRecordSeparator(value);
			
			if ($.isFunction(this.options.showResult)) {
				return this.options.showResult(htmlEscape(fValue),data);
			} else {
				return htmlEscape(fValue);
			}
		}
		var searchTerms = [];
		searchTerms = escapeRegexp(terms).split(' ');
		
		// Remove empty searchterms (because of multiple spaces)
		var iTerms = searchTerms.length;
		for (var i = 0; i < iTerms; i++) {
			if (String(searchTerms[i]) == '') {
				searchTerms.splice(i,1);
				i--;
			}
		}
		
		// Helaas kan dit niet met een simpele replace van meerdere woorden, probleem is dan al de tekst van te voren
		// ge-escapet is dat dan die text ook kan worden gevonden. Andersom worden de highlight tags ge-escapet. Ook
		// niet de bedoeling. Wel moeten alle woorden tegelijkertijd vervangen worden. Anders kan de ene zoekterm in
		// de andere gehighlighte term gevonden worden (woordception!). Vandaar deze twee loops.
		
		
		//html-safe versie van value
		var htValue = ''; 
		
		if (searchTerms.length > 0) {
			var re = new RegExp("(" + searchTerms.join("|") + ")",'ig');
			var matches = [];
			var match = '';
			
			// Vind de positie en lengte van alle gevonden zoektermen
			while (null != (match = re.exec(value))) {
				matches.push({'length': match[0].length, 'pos': re.lastIndex - match[0].length});
			}
			
			var position = 0; 
			var parts = [];
			
			// Hak de string in stukjes gevonden termen en niet gevonden termen.
			var iMatches = matches.length;
			for (var i = 0; i < iMatches; i++) {
				var match = matches[i];
				parts.push(htmlEscape(value.substr(position,match.pos - position)));
				parts.push("<span class='acMatch'>" + htmlEscape(value.substr(match.pos,match.length)) + "</span>");
				position = match.pos + match.length;
			}
			
			// Niet het stuk achter de laatste term vergeten.
			parts.push(htmlEscape(value.substr(position, value.length)));
			
			htValue = parts.join('');
		} else {
			htValue = htmlEscape(value);
		}
		
		//er vanuit gaand dat de field separator nooit gezocht wordt:
		htValue = this.filterRecordSeparator(htValue);
		
		
		if ($.isFunction(this.options.showResult)) {
			return this.options.showResult(htValue,data);
		} else {
			return htValue;
		}
	};
	



})(jQuery);

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
